import { ContactProperties } from 'forms-utils-lib/constants/Properties';
const getConfigurationType = field => {
  if (field.name === ContactProperties.phone || field.name === ContactProperties.mobilephone) {
    return ContactProperties.phone;
  }
  return field.fieldType;
};
export default getConfigurationType;